import type { CSSProperties, ReactNode } from 'react'

export interface CardProps {
  surface?: 'default' | 'hero'
  padding?: string
  children: ReactNode
  style?: CSSProperties
}

export function Card({ surface = 'default', padding, children, style }: CardProps) {
  const isHero = surface === 'hero'
  const baseStyle: CSSProperties = {
    background: isHero ? 'var(--gradient-hero)' : 'var(--color-surface)',
    color: isHero ? 'white' : 'var(--color-text)',
    border: isHero ? 'none' : '1px solid var(--color-border)',
    borderRadius: isHero ? 'var(--radius-xl)' : 'var(--radius-lg)',
    padding: padding ?? 'var(--space-4)',
    ...style,
  }
  return <div style={baseStyle}>{children}</div>
}
